import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import ProtectedRoute from './ProtectedRoute';
import PermissionRoute from './PermissionRoute';
import SmartRedirect from './SmartRedirect';
// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));

// render - color
const Color = Loadable(lazy(() => import('pages/component-overview/color')));
const Typography = Loadable(lazy(() => import('pages/component-overview/typography')));
const Shadow = Loadable(lazy(() => import('pages/component-overview/shadows')));

// render - Pages
const Clients = Loadable(lazy(() => import('pages/Module/Clients')));
const Project = Loadable(lazy(() => import('pages/Module/Project')));
const ProjectDetails = Loadable(lazy(() => import('pages/Module/ProjectDetails')));
const DataEditor = Loadable(lazy(() => import('pages/Module/DataEditor')));
const ChartTemplateEditor = Loadable(lazy(() => import('pages/Module/ChartTemplateEditor')));
const ErrorPage = Loadable(lazy(() => import('pages/error_page')));

// render - Admin
const UserManagement = Loadable(lazy(() => import('pages/Admin/UserManagement')));
const CompanyManagement = Loadable(lazy(() => import('pages/Admin/CompanyManagement')));
const ClientAdminUserManagement = Loadable(lazy(() => import('pages/Admin/ClientAdminUserManagement')));
const ClientProjects = Loadable(lazy(() => import('pages/Admin/ClientProjects')));

// render - Project Management
const ThemeManagement = Loadable(lazy(() => import('pages/ProjectManagement/ThemeManagement')));
const ChartTemplateManagement = Loadable(lazy(() => import('pages/ProjectManagement/ChartTemplateManagement')));

// ==============================|| MAIN ROUTING ||============================== //
const MainRoutes = {
  path: '/home',
  element: <DashboardLayout />,
  errorElement: <ErrorPage />,
  children: [
    {
      index: true,
      element: (
        <ProtectedRoute>
          {' '}
          <SmartRedirect />{' '}
        </ProtectedRoute>
      )
    },
    {
      path: 'dashboard',
      element: (
        <ProtectedRoute>
          {' '}
          <DashboardDefault />{' '}
        </ProtectedRoute>
      )
    },
    {
      path: 'clients',
      element: (
        <ProtectedRoute>
          {' '}
          <PermissionRoute permission="clients.access">
            {' '}
            <Clients />{' '}
          </PermissionRoute>{' '}
        </ProtectedRoute>
      )
    },
    {
      path: 'project/:clientCode',
      element: (
        <ProtectedRoute>
          {' '}
          <PermissionRoute permission="projects.access">
            {' '}
            <Project />{' '}
          </PermissionRoute>{' '}
        </ProtectedRoute>
      )
    },
    {
      path: 'projectdetails/:projectCode',
      element: (
        <ProtectedRoute>
          {' '}
          <ProjectDetails />{' '}
        </ProtectedRoute>
      )
    },
    {
      path: 'projectdata/:projectCode',
      element: (
        <ProtectedRoute>
          {' '}
          <PermissionRoute permission="data.edit">
            {' '}
            <DataEditor />{' '}
          </PermissionRoute>{' '}
        </ProtectedRoute>
      )
    },
    {
      path: 'admin/users',
      element: (
        <ProtectedRoute>
          {' '}
          <PermissionRoute permission="admin.access">
            {' '}
            <UserManagement />{' '}
          </PermissionRoute>{' '}
        </ProtectedRoute>
      )
    },
    {
      path: 'admin/companies',
      element: (
        <ProtectedRoute>
          {' '}
          <PermissionRoute permission="admin.access">
            {' '}
            <CompanyManagement />{' '}
          </PermissionRoute>{' '}
        </ProtectedRoute>
      )
    },
    {
      path: 'project-management/themes',
      element: (
        <ProtectedRoute>
          {' '}
          <PermissionRoute permission="projectManagement.themes.access">
            {' '}
            <ThemeManagement />{' '}
          </PermissionRoute>{' '}
        </ProtectedRoute>
      )
    },
    {
      path: 'project-management/chart-templates',
      element: (
        <ProtectedRoute>
          {' '}
          <PermissionRoute permission="projectManagement.templates.access">
            {' '}
            <ChartTemplateManagement />{' '}
          </PermissionRoute>{' '}
        </ProtectedRoute>
      )
    },
    {
      path: 'project-management/chart-templates/new',
      element: (
        <ProtectedRoute>
          {' '}
          <PermissionRoute permission="projectManagement.templates.access">
            {' '}
            <ChartTemplateEditor />{' '}
          </PermissionRoute>{' '}
        </ProtectedRoute>
      )
    },
    {
      path: 'project-management/chart-templates/edit/:templateId',
      element: (
        <ProtectedRoute>
          {' '}
          <PermissionRoute permission="projectManagement.templates.access">
            {' '}
            <ChartTemplateEditor />{' '}
          </PermissionRoute>{' '}
        </ProtectedRoute>
      )
    },
    {
      path: 'client-admin/users',
      element: (
        <ProtectedRoute>
          {' '}
          <PermissionRoute permission="client_admin.access">
            {' '}
            <ClientAdminUserManagement />{' '}
          </PermissionRoute>{' '}
        </ProtectedRoute>
      )
    },
    {
      path: 'client-admin/projects',
      element: (
        <ProtectedRoute>
          {' '}
          <PermissionRoute permission="client_portal.access">
            {' '}
            <ClientProjects />{' '}
          </PermissionRoute>{' '}
        </ProtectedRoute>
      )
    },
    {
      path: 'typography',
      element: (
        <ProtectedRoute>
          {' '}
          <Typography />{' '}
        </ProtectedRoute>
      )
    },
    {
      path: 'color',
      element: (
        <ProtectedRoute>
          {' '}
          <Color />{' '}
        </ProtectedRoute>
      )
    },
    {
      path: 'shadow',
      element: (
        <ProtectedRoute>
          {' '}
          <Shadow />{' '}
        </ProtectedRoute>
      )
    }
  ]
};

export default MainRoutes;
